import { createClient, SupabaseClient } from '@supabase/supabase-js';
export const AUTH_STORAGE_KEY = 'bottom-up-auth-session';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- import.meta.env is Vite-specific; undefined in Next.js
const env = (typeof import.meta !== 'undefined' && (import.meta as any).env) || {};

const supabaseUrl = env.VITE_SUPABASE_URL;
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('[supabase] Missing browser env for Supabase client.', {
        hasSupabaseUrl: Boolean(supabaseUrl),
        hasSupabaseAnonKey: Boolean(supabaseAnonKey),
        appEnv: env.VITE_APP_ENV,
        mode: env.MODE,
    });
} else {
    console.info('[supabase] Browser env detected.', {
        supabaseUrl,
        appEnv: env.VITE_APP_ENV,
        mode: env.MODE,
    });
}

export const supabase = createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder-anon-key', {
        auth: {
            storageKey: AUTH_STORAGE_KEY, autoRefreshToken: true, persistSession: true,
        }
    }
) as SupabaseClient;
